import axios from 'axios'

const cache = new Map()
const inFlight = new Map()

export function useClientNoteCache() {
    function fetchNote(email) {
        if (!email) {
            return Promise.resolve(null)
        }
        if (cache.has(email)) {
            return Promise.resolve(cache.get(email))
        }
        if (inFlight.has(email)) {
            return inFlight.get(email)
        }

        const promise = axios.get('/app/contacts/note-by-email', { params: { email } })
            .then(({ data }) => {
                cache.set(email, data)
                inFlight.delete(email)
                return data
            })
            .catch(() => {
                inFlight.delete(email)
                return null
            })

        inFlight.set(email, promise)
        return promise
    }

    return { fetchNote }
}
